import React from 'react'
import gql from 'graphql-tag'
import moment from 'moment'
import Query from 'shared/components/Query'
import BookingsList from 'components/shared/BookingsList'

const PreviousBookingsQuery = gql`
  query PreviousBookingsQuery($first: Int, $before: DateTime, $sortDirection: SortDirection) {
    serviceProvider {
      id
      bookings(first: $first, startsBeforeDateTime: $before, sortByEndsAt: $sortDirection) {
        ...BookingsList
      }
    }
  }
  ${BookingsList.fragments.bookingsList}
`

const PreviousBookings = () => {
  const before = moment().startOf('day').format()

  return (
    <Query
      query={PreviousBookingsQuery}
      variables={{first: 30, before, sortDirection: 'desc'}}
      inlineLoading
      inlineError
    >
      {({getData}) => {
        const bookings = getData('serviceProvider.bookings', {edges: []})
        if (bookings.edges.length === 0) {
          return (
            <div>Du har ingen tidligere bookinger</div>
          )
        }
        return <BookingsList bookings={bookings} />
      }}
    </Query>
  )
}

export default PreviousBookings
